// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gpl8","type":"styles_type__1R9ae","choices":"styles_choices__2avyG"};